export const PRODUCT_HUB_APP_ID = '#root';
